import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { resetStore, resetWeights, calculateWeights } from '../Functions';
import { Weights } from '../Store';
import { Svgs } from '../components/Svgs';

class ResultsRecommendations extends Component {

  constructor(props) {
    super(props);

    this.startAgain = this.startAgain.bind(this);

    this.state = {
      recomendations: null
    };
  }

  componentDidMount() {

    // FOR TESTING ONLY
    if (process.env.NODE_ENV === 'development') {
      calculateWeights();
    }

    document.querySelector('.app').classList.add('screen--results-recommendations');
    this.dom = ReactDOM.findDOMNode(this);
    void this.dom.offsetWidth;
    this.dom.classList.add('results-recommendations--animate-in');
    this.displaySolutions();
    window.scrollTo(0,0);

  }

  componentWillUnmount() {
    document.querySelector('.app').classList.remove('screen--results-recommendations');
  }

  startAgain = (e, history) => {
    resetStore();
    resetWeights();
    history.push('/');
  }

  previewSolution = (e, key) => {
    this.props.overlayMessage({
      close: true,
      title: key.solution,
      class: 'overlay--solution',
      copy: key.information,
      component: <Svgs width="100" height="100" svg={key.icon} class="overlay--solution__icon" />
    });
    this.props.overlayToggle(true);
  }

  displaySolutions(){

    //console.log(Weights);

    let solutionsDisplay = Weights.map((key, x) => {

      if (key.value > 0) {
        
        return (
          <div key={x} className="results-recommendations__solution-cat">
            <h3>{Weights[x].category}</h3>
            <ul className="results-recommendations__solution-cat-list" key={x}>
              
              {Weights[x].solutions.map((key, i) => {

                let SolutionName = key.solution;
                let SolutionIcon = key.icon;

                if (key.weight > 0) {
                  return (
                    <li key={i}><button type="button" data-title={SolutionName} onClick={(e) => this.previewSolution(e, key)}><Svgs svg={SolutionIcon} class="results-recommendations__solution-icon" /></button></li>
                  );
                } else {
                  return false;
                }
              })}
            </ul>
          </div>
        );

      } else {
        return false;
      }

    });

    this.setState({
      recomendations: solutionsDisplay
    });

  }
  
  render() {
    const history = this.props.history;

    return (
      <div className="results-recommendations">
        <h1 className="h2">Thank You</h1>
        <div className="results-recommendations__solution">
          <div className="results-recommendations__solution-copy">
            <p>Faccum eosserspis simaximus moor comniatae ne is doluptisi rectionsed quasperovid et dolorep etro muionden.</p>
            <p>Speak to your account director for more information on these products.</p>
          </div>
          <div className="results-recommendations__solution-list">
            {this.state.recomendations}
            {/*<div className="results-recommendations__solution-cat">
              <h3>Access</h3>
              <ul className="results-recommendations__solution-cat-list">
                <li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="MerchantServices" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li>
              </ul>
            </div>
            <div className="results-recommendations__solution-cat">
              <h3>Identity</h3>
              <ul className="results-recommendations__solution-cat-list">
                <li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li>
              </ul>
            </div>
            <div className="results-recommendations__solution-cat">
              <h3>Pay</h3>
              <ul className="results-recommendations__solution-cat-list">
                <li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li>
              </ul>
            </div>
            <div className="results-recommendations__solution-cat">
              <h3>Deliver</h3>
              <ul className="results-recommendations__solution-cat-list">
                <li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li><li>
                  <Svgs svg="CashDisbursement" class="results-recommendations__solution-icon" />
                </li>
              </ul>
            </div>*/}
          </div>
        </div>
        <button type="button" onClick={(e) => this.startAgain(e, history)} className="btn"><span>Start again</span> <Svgs width="8" height="8" svg="RightChevron" /></button>
      </div>
    );
  }
}

export default ResultsRecommendations;



// WEBPACK FOOTER //
// ./src/screens/ResultsRecommendations.js